// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f45e2180","732":"b72cba4a","977":"832adc85"}[chunkId] + ".chunk.js";
};